import { initialAbility } from '@/libs/acl/config'

/**
 * Update ability rules for user
 * @param {Object} user
 * @param {Object} ability
 */
export default (user, ability) => {
  if (user && ability) {
    const rules = [...initialAbility]

    rules.push({
      action: 'manage',
      subject: user.role === 'Admin' ? 'all' : user.role,
    })

    if (user.role === 'Company Owner') {
      rules.push({
        action: 'manage',
        subject: 'Supervisor',
      })
    }

    ability.update(rules)
  }
}
